'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = _update;

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _update(entry, updates) {
    entry = (0, _extends4.default)({}, entry, updates);

    entry.data = entry.data && (0, _extends4.default)({}, entry.data, (0, _defineProperty3.default)({}, _constants.ENTRY, entry));

    if (entry.error) entry.error[_constants.ENTRY] = entry;

    return entry;
}